import React from 'react';
import { makeStyles } from '@material-ui/core/styles'; 
import { Box } from '@material-ui/core';
import { ToolbarSection, ToolbarItem } from '../../editor';
import { ToolbarRadio } from '../../editor/Toolbar/ToolbarRadio';

const useStyles = makeStyles((theme) => ({
  colorPreviewWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  colorBox: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: '50%',
    boxShadow: theme.shadows[1], 
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const SignatureSettings = () => {
  const classes = useStyles();
	return (
		<React.Fragment>
			
			<ToolbarSection	
				title="Contenido"
				props={['signatureText']}
				summary={({ signatureText }) => {
					return `Texto: "${signatureText}"`;
				}}
			>
				<ToolbarItem	
					propKey="signatureText"	
					type="text"	
					label="Texto"	
					debounce={0}
				/>
			</ToolbarSection>
			
      <ToolbarSection
        title="Estilos"
        props={['backgroundColor']}
        summary={({ backgroundColor }) => {
          const backgroundStyle = backgroundColor ? 
            `rgba(${Object.values(backgroundColor).join(',')})` :
            'transparent';
          return (
            <div className={classes.colorPreviewWrapper}>
              <Box
                className={classes.colorBox}
                style={{
                  backgroundColor: backgroundStyle,
                }}
              />
            </div>
          );
        }}
        >
        <ToolbarItem
          full={true}
          propKey="backgroundColor"
          type="bg"
          label="Color de Fondo"
        />
      </ToolbarSection>
      
			<ToolbarSection	
				title="Dimensiones"
				props={['width', 'height']}
				summary={({ width, height }) => {
					return `Ancho: ${width || '240px'}, Alto: ${height || '120px'}`; 
				}}
			>
				<ToolbarItem	
					propKey="width"	
					type="text"	
					label="Ancho"	
				/>
        <ToolbarItem	
					propKey="height"	
					type="text"	
					label="Alto"	
				/>
			</ToolbarSection>
			
			<ToolbarSection title="Alineación">
				<ToolbarItem propKey="alignSelf" type="radio" label="Alineación">
					<ToolbarRadio value="flex-start" label="Izquierda" />
					<ToolbarRadio value="center" label="Centro" />
					<ToolbarRadio value="flex-end" label="Derecha" />
				</ToolbarItem>
			</ToolbarSection>
			
			<ToolbarSection
				title="Márgenes"
				props={['margin']}
				summary={({ margin }) => {
					return `${margin[0] || 0}px ${margin[1] || 0}px ${margin[2] || 0}px ${margin[3] || 0}px`;
				}}
			>
				<ToolbarItem propKey="margin" index={0} type="slider" label="Superior" />
				<ToolbarItem propKey="margin" index={1} type="slider" label="Derecho" />
				<ToolbarItem propKey="margin" index={2} type="slider" label="Inferior" />
				<ToolbarItem propKey="margin" index={3} type="slider" label="Izquierdo" />
			</ToolbarSection>
		</React.Fragment>
	);
};
